import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../components/landing/Navbar";
import Hero from "../components/landing/Hero";
import StatsBar from "../components/landing/StatsBar";
import Services from "../components/landing/Services";
import Values from "../components/landing/Values";
import Properties from "../components/landing/Properties";
import PlotsPreview from "../components/landing/PlotsPreview";
import Contact from "../components/landing/Contact";
import Footer from "../components/landing/Footer";
import WhatsAppButton from "../components/landing/WhatsAppButton";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LandingPage = () => {
  const [data, setData] = useState({
    hero: {}, stats: {}, services: [], projects: [],
    values: {}, contact: {}, footer: {}, settings: {},
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [hero, stats, services, projects, values, contact, footer, settings] = await Promise.all([
          axios.get(`${API}/content/hero`),
          axios.get(`${API}/content/stats`),
          axios.get(`${API}/services`),
          axios.get(`${API}/projects`),
          axios.get(`${API}/content/values`),
          axios.get(`${API}/content/contact`),
          axios.get(`${API}/content/footer`),
          axios.get(`${API}/content/settings`),
        ]);
        setData({
          hero: hero.data.data || {},
          stats: stats.data.data || {},
          services: services.data || [],
          projects: projects.data || [],
          values: values.data.data || {},
          contact: contact.data.data || {},
          footer: footer.data.data || {},
          settings: settings.data.data || {},
        });
      } catch (e) {
        console.error("Failed to load content", e);
      } finally {
        setLoading(false);
      }
    };
    fetchAll();
    // Track visit
    axios.post(`${API}/track-visit`, { path: "/" }).catch(() => {});
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#173269]">
        <div className="flex flex-col items-center gap-4">
          <img
            src="https://customer-assets.emergentagent.com/job_elite-realty-40/artifacts/sgxznx1v_image.png"
            alt="الوسيم العقارية"
            className="w-32 h-32 object-contain animate-pulse"
          />
          <div className="w-12 h-12 border-4 border-[#ecc775] border-t-transparent rounded-full animate-spin"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="font-cairo" dir="rtl">
      <Navbar contact={data.contact} logo={data.settings?.logo_url} />
      <Hero hero={data.hero} />
      <StatsBar stats={data.stats} />
      <Services services={data.services} />
      <Values values={data.values} />
      <Properties projects={data.projects} contact={data.contact} />
      <PlotsPreview contact={data.contact} />
      <Contact contact={data.contact} />
      <Footer footer={data.footer} contact={data.contact} logo={data.settings?.logo_url} />
      <WhatsAppButton whatsapp={data.contact.whatsapp || "966555661937"} />
    </div>
  );
};

export default LandingPage;
